import type { BusbarResult } from '../../../..';
import type {
  BusbarEvaluatedVoltages,
  BusbarEvaluatedVoltageDiffTransformerEndPercents
} from '../../../../derived-state/loadFlowSummary';
import { NumbersRange } from '../../../../domain/NumbersRange';
import { Messenger } from '../../../AttentionStatusRepository';
import type { ForBusbarEvaluation } from './forBusbarEvaluation';

export class BusbarSummaryEvaluation {
  private busbarResults: BusbarResult[];
  private evaluationEngine: ForBusbarEvaluation;

  constructor(
    busbarResults: BusbarResult[],
    evaluationEngine: ForBusbarEvaluation
  ) {
    this.busbarResults = busbarResults;
    this.evaluationEngine = evaluationEngine;
  }

  evaluateVoltages(): BusbarEvaluatedVoltages {
    const voltages = this.busbarResults.map(e => e.voltage);

    const voltageRange = new NumbersRange(voltages);
    const min = this.evaluationEngine.evaluateVoltage(
      voltageRange.min,
      Messenger.notDelegated()
    );
    const max = this.evaluationEngine.evaluateVoltage(
      voltageRange.max,
      Messenger.notDelegated()
    );

    return { min, max };
  }

  evaluateVoltageDiffTransformerEndPercents(): BusbarEvaluatedVoltageDiffTransformerEndPercents {
    const voltageDiffTransformerEndPercents = this.busbarResults.map(e =>
      Math.abs(e.voltageDiffTransformerEndPercent)
    );

    const voltageRange = new NumbersRange(voltageDiffTransformerEndPercents);
    const min = this.evaluationEngine.evaluateVoltageDiffTransformerEndPercent(
      voltageRange.min,
      Messenger.notDelegated()
    );
    const max = this.evaluationEngine.evaluateVoltageDiffTransformerEndPercent(
      voltageRange.max,
      Messenger.notDelegated()
    );

    return { min, max };
  }
}
